import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MuiFormGroup from '@mui/material/FormGroup';
import MuiFormHelperText from '@mui/material/FormHelperText';
import MuiRadio from '@mui/material/Radio';
import * as React from 'react';
import { FormControlLabel, FormControlLabelWithDescription } from '../form-control';
import { sentence, Typography } from '../typography';
import { makeEnum, withVersion } from '../utils';
import { RadioGroupContext } from './context';
const sizes = ['small', 'medium', 'large'];
export const RadioSize = makeEnum(...sizes);
const RadioImpl = (props) => {
    const { label, description, error, labelPlacement, onChange, size, className, ...muiProps } = props;
    const inGroup = React.useContext(RadioGroupContext);
    const control = (_jsx(MuiRadio, { onChange: (e) => onChange?.(e.target.checked, e), size: size === 'large' ? 'medium' : size, className: size === 'large'
            ? `MuiRadio-sizeLarge ${className ?? ''}`
            : className, ...muiProps }));
    if (!label) {
        return control;
    }
    const content = (_jsxs(_Fragment, { children: [description ? (_jsx(FormControlLabelWithDescription, { control: control, label: _jsx(Typography, { textTransform: "sentence", color: muiProps.disabled ? 'text.disabled' : undefined, children: label }), description: description, labelPlacement: labelPlacement })) : (_jsx(FormControlLabel, { control: control, label: _jsx(Typography, { textTransform: "sentence", color: muiProps.disabled ? 'text.disabled' : undefined, children: label }), disableTypography: true, labelPlacement: labelPlacement })), error && (_jsx(MuiFormHelperText, { error: true, children: sentence(error) }))] }));
    return inGroup ? content : _jsx(MuiFormGroup, { children: content });
};
export const Radio = withVersion(RadioImpl, '1.0.0');
export const radioStyle = {
    MuiRadio: {
        styleOverrides: {
            root: {
                '& input[type=radio]': {
                    marginTop: 0
                },
                '&.MuiRadio-sizeLarge .MuiSvgIcon-root': {
                    fontSize: 28
                }
            }
        }
    }
};
export { RadioGroup } from './RadioGroup';
